import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import { colorTokens } from './tokens';

export const buildTheme = (mode = 'light') => {
  const palette = colorTokens[mode] || colorTokens.light;

  let theme = createMuiTheme({
    palette: {
      type: mode,
      primary: {
        main: mode === 'light' ? '#3f4b3f' : '#8a9a84',
        dark: mode === 'light' ? '#2b352b' : '#6f7f69',
        light: mode === 'light' ? '#5a6a59' : '#a9b89f',
      },
      secondary: {
        main: palette.accent,
      },
      background: {
        default: palette.background,
        paper: palette.paper,
      },
      text: {
        primary: palette.textPrimary,
        secondary: palette.textSecondary,
      },
    },
    typography: {
      fontFamily: '"Manrope", sans-serif',
      h1: { fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-0.02em' },
      h2: { fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-0.02em' },
      h3: { fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-0.02em' },
      h4: { fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-0.02em' },
      h5: { fontFamily: '"Playfair Display", serif', fontWeight: 700, letterSpacing: '-0.01em' },
      h6: { fontFamily: '"Manrope", sans-serif', fontWeight: 700 },
      button: { textTransform: 'none', fontWeight: 700 },
      overline: { letterSpacing: '0.12em', fontWeight: 700 },
    },
    shape: {
      borderRadius: 16,
    },
    overrides: {
      MuiPaper: {
        rounded: {
          borderRadius: 16,
        },
      },
      MuiButton: {
        root: {
          borderRadius: 14,
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
  });

  theme = responsiveFontSizes(theme);
  return theme;
};
